var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import _ from 'lodash';
import moment from 'moment';
import AreaShop from "@/components/AreaShop";
var initFormData = {
    keyword_type: 1,
    keyword: '',
    time_type: 1,
    s_time: moment().subtract(30, 'days').format('YYYY-MM-DD'),
    e_time: moment().format('YYYY-MM-DD'),
    order_status: [1, 2, 7],
};
var BillHeader = (function (_super) {
    __extends(BillHeader, _super);
    function BillHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formData = __assign({}, initFormData);
        _this.isMoreSearch = false;
        _this.dateTypeList = [
            { name: '制单时间', id: 1 },
            { name: '审核时间', id: 2 },
            { name: '废弃时间', id: 3 },
            { name: '驳回时间', id: 4 },
        ];
        _this.statusList = [
            { name: '全部', value: "" },
            { name: '待审核', value: 1 },
            { name: '已审核', value: 2 },
            { name: '已废弃', value: 6 },
            { name: '已驳回', value: 7 },
        ];
        return _this;
    }
    BillHeader.prototype.mounted = function () {
        this.areaShopComp = this.$refs.areaShopRef;
        this.areaShopComp.getArea();
        this.search();
    };
    BillHeader.prototype.search = function () {
        var areaShopFormData = this.$refs.areaShopRef.getFormData();
        this.formData = _.extend(this.formData, areaShopFormData);
        this.$emit('search', __assign({}, this.formData));
    };
    BillHeader.prototype.reset = function () {
        this.formData = __assign({}, initFormData);
        this.areaShopComp.resetData();
    };
    BillHeader.prototype.moreSearchComShow = function () {
        this.isMoreSearch = true;
        window._czc.push(["_trackEvent", '退货入库高级查询', '高级查询展开']);
    };
    BillHeader.prototype.moreSearchComHide = function () {
        this.isMoreSearch = false;
        window._czc.push(["_trackEvent", '退货入库高级查询', '高级查询收起']);
    };
    BillHeader = __decorate([
        Component({
            components: {
                "areaShop": AreaShop
            }
        })
    ], BillHeader);
    return BillHeader;
}(Vue));
export default BillHeader;
